// extracted by mini-css-extract-plugin
export default {"liveopsTournamentsEditModalContentWrapper":"LiveOpsTournamentsEditModal_liveopsTournamentsEditModalContentWrapper__3OpD8","title":"LiveOpsTournamentsEditModal_title__DV5Gl"};